import React, { Component } from "react";
import { connect } from "react-redux";
import { saveProfile } from "../actions/accountActions";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import MyProfileForm from './MyProfileForm';
import OrdersList from './OrdersList';
import OrderDetails from '../components/OrderDetails';
import Wishlist from './Wishlist';
import { ProfileNavSectionsEnum } from "../common/enums";
import { withTranslation } from 'react-i18next';
import { utils} from "../common/utils";
import ExtendedLink  from "../components/ExtendedLink";
import Image from "../components/Image";
import NewWindow from "../components/NewWindow";
import ReferralDashboard from "../components/ReferralDashboard";
import LoyaltyDashboard from "../components/Loyalty/LoyaltyDashboard";
import Dashboard from "../components/Dashboard";
import CustomerZones from "../components/CustomerZones";
import { getCustomerDashboardData , getCustomerZoneData } from "../actions/dashboardActions";
import { getCustomerAvailableLoyaltyPointsBalance } from "../actions/loyaltyActions";


class MyProfile extends Component {
    state = { visibleWindow: false, selectedOrderId: 0 }
    sectionRef = React.createRef();
    // componentDidMount() {
    //     const { user, customerDashboardData, getCustomerDashboardData } = this.props;

    //     if (user?.id && !customerDashboardData) {
    //         getCustomerDashboardData(user.id);
    //     }
    // }
    componentDidUpdate(prevProps) {
        if (prevProps.navSection !== this.props.navSection && window.innerWidth <= 768 && this.sectionRef.current) {
            const sectionEl = this.sectionRef.current;
            // Defer to run after ScrollToTop's componentDidUpdate starts its jQuery animation, then stop it and scroll to section
            setTimeout(() => {
                window.$("html, body").stop(true);
                const offset = sectionEl.getBoundingClientRect().top + window.pageYOffset - 300;
                window.$("html, body").animate({ scrollTop: offset }, 300);
            }, 0);
        }
    }

    componentDidMount() {
        const { settings, user, customerDashboardData, customerZoneData, getCustomerDashboardData, getCustomerZoneData } = this.props;
        if (settings.isLoyaltyProgramFeatureEnabled && user && user.isAuthenticated === true) {
            this.props.getCustomerAvailableLoyaltyPointsBalance();
        }
    if(user && user.id && !customerZoneData) {
            getCustomerZoneData(user.id);
        }
    }

    updateProfileHandler(values) {
        const { user } = this.props;
        values.representative = user.representative;
        return this.props.saveProfile(values).then((response) => {
          //  console.log(response)
        }, (error) => {
            console.log(error)
        });
    }

    onSelectOrder(orderId) {
        this.setState({
            selectedOrderId: orderId,
            visibleWindow: true
        });
    }

    onCloseWindow = () => {
             // Clear Selected Order
        this.setState({
            visibleWindow: false,
            selectedOrderId: 0
        });
    }

    render() {
        const { t, user, settings, wishlist, selectedOrder,customerZoneData } = this.props; //customerDashboardData
        if (user.isAuthenticated !== true) {
            return <Redirect to={settings.baseUrl} />;
        }

        let imageUrl = user.imageUrl ? user.imageUrl : settings.defaultImageUrl;
        imageUrl = imageUrl || "img/account/default-user-ava.png";

        const navSection = this.props.navSection ? this.props.navSection.toLowerCase() : (settings.isAppMode === true ? "" : ProfileNavSectionsEnum.Profile);
        let section = settings.isAppMode === true ? <div></div> : <MyProfileForm />;
        // console.log(navSection)
        // console.log(section)
        if (navSection === ProfileNavSectionsEnum.Orders)
            section = <OrdersList onSelectOrder={this.onSelectOrder.bind(this)} />;
        else if (navSection === ProfileNavSectionsEnum.Wishlist)
            section = <Wishlist />;
        else if (navSection === ProfileNavSectionsEnum.Referral && settings.isReferralProgramEnabled === true)
            section = <ReferralDashboard></ReferralDashboard>;
        else if (navSection === ProfileNavSectionsEnum.Loyalty && settings.isLoyaltyProgramFeatureEnabled === true)
            section = <LoyaltyDashboard />;
        else if (navSection === ProfileNavSectionsEnum.Dashboard)
            section = <Dashboard zones={customerZoneData}/>;
        else if (navSection === ProfileNavSectionsEnum.Profile)
            section = <MyProfileForm />;

        return (
            <div>
            <div className="row">
                {/*{this.state.visibleWindow && <Window title={`${t("Order")}#${this.state.selectedOrderId}`} onClose={this.onCloseWindow} initialTop={position.top} initialLeft={position.left} initialHeight={dimenstions.height} initialWidth={dimenstions.width}>*/}
                {/*    <OrderDetails order={selectedOrder} />*/}
                {/*</Window>}*/}

                <NewWindow title={`${t("Order")}#${this.state.selectedOrderId}`} open={this.state.visibleWindow} onClose={this.onCloseWindow} >
                    <OrderDetails order={selectedOrder} settings={settings} />
                </NewWindow>
                    <div className="col-md-4 col-lg-3">
                        {settings.isAppMode === true ? (
                            <div style={{ textAlign: "center", padding: "15px 10px 20px 10px" }}>
                                <h6>{`${user.firstName} ${user.lastName}`}</h6>
                                <div style={{ marginBottom: "12px" }}>
                                    <i className="icon-medal" style={{ marginRight: "3px", fontSize: "1.2em", verticalAlign: "middle" }}></i>
                                    {user?.loyaltyPointsBalance ?? 0} {t("points")}
                                </div>
                                <CustomerZones zones={customerZoneData} />
                            </div>
                        ) : (
                            <aside
                            className="user-info-wrapper" style={{
                                position: "relative",
                                width: "100%",
                                paddingTop: "0px",
                                paddingBottom: "0px",
                                marginBottom: "-1px",
                                border: "1px solid #d1d5db",
                                borderTopLeftRadius: "7px",
                                borderTopRightRadius: "7px",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <div style={{ padding: "10px 18px", position: "relative" }} >
                                <CustomerZones zones={customerZoneData} />
                            </div>

                            <div className="user-info" style={{ display: "flex", alignItems: "center", width: "100%", padding: "15px 10px", zIndex: 5 }}>
                                <div className="user-avatar" style={{ width: "30%" }}>
                                    <a className="edit-avatar" href={null} role="button">{" "}</a>
                                    {imageUrl && <Image src={imageUrl} fallbackSrc="img/no-image.jpg" alt="" />}
                                </div>

                                <div className="user-data" style={{ paddingTop: "0px", width: "70%" }}>
                                    <h6>{`${user.firstName} ${user.lastName}`}</h6>
                                   <span> {t("Joined")} {utils.dates.getDateString(user.createdAt)} </span>
                                   {/*<div style={{ padding: "0 10px", borderRadius: "13px", backgroundColor: "#ffffff",*/}
                                   {/* color: "#606975", fontSize: "12px", lineHeight: "26px", boxShadow: "0 1px 5px rgba(0,0,0,0.18)",cursor: "pointer"}}>*/}
                                   {/* <i className="icon-medal" style={{ marginRight: "3px", fontSize: "1.2em", verticalAlign: "middle" }}></i> {user?.loyaltyPointsBalance ?? 0} {t("points")}                               */}
                                   {/*</div>*/}
                                    <i className="icon-medal" style={{ marginRight: "3px", fontSize: "1.2em", verticalAlign: "middle" }}></i> {user?.loyaltyPointsBalance ?? 0} {t("points")}

                                </div>

                            </div>

                        </aside>
                        )}
                        <nav className="list-group">
                            <ExtendedLink to={`${settings.baseUrl}account/profile`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Profile ? "active" : ""} `}>
                            <i className="icon-head"></i>{t("Profile")}
                            </ExtendedLink>
                            <ExtendedLink to={`${settings.baseUrl}account/orders`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Orders ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Orders")}<span className="badge badge-primary badge-pill">{user.totalOrdersCount}</span>
                            </ExtendedLink>
                            <ExtendedLink to={`${settings.baseUrl}account/wishlist`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Wishlist ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Wishlist")}<span className="badge badge-primary badge-pill">{wishlist ? wishlist.length : 0}</span>
                            </ExtendedLink>
                            {settings.isReferralProgramEnabled === true &&
                                <ExtendedLink to={`${settings.baseUrl}account/referral`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Referral ? "active" : ""} `}>
                                <i className="icon-bag"></i>{t("Referral Program")}
                                {/* <span className="badge badge-primary badge-pill">{wishlist ? wishlist.length : 0}</span> */}
                                </ExtendedLink>
                            }
                            {settings.isLoyaltyProgramFeatureEnabled === true &&
                                <ExtendedLink to={`${settings.baseUrl}account/loyalty`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Loyalty ? "active" : ""} `}>
                                    <i className="icon-bag"></i>{t("Loyalty Program")}
                                </ExtendedLink>
                            }
                            {/*
                            <a className="list-group-item with-badge" href="account-wishlist.html"><i className="icon-heart"></i>Wishlist<span className="badge badge-primary badge-pill">3</span>
                            </a>
                            <a className="list-group-item with-badge" href="account-tickets.html"><i className="icon-tag"></i>My Tickets<span className="badge badge-primary badge-pill">4</span>
                            </a>*/}
                            <ExtendedLink to={`${settings.baseUrl}account/Dashboard`} className={`list-group-item with-badge ${navSection === ProfileNavSectionsEnum.Dashboard ? "active" : ""} `}>
                            <i className="icon-bag"></i>{t("Dashboard")}
                            </ExtendedLink>

                        </nav>
                    </div>
                    <div className="col-md-8 col-lg-9 mt-2" ref={this.sectionRef}>
                        {section}
                    </div>
                </div>
                </div>
        );
    }
}



function mapStateToProps({ user, settings, wishlist, selectedOrder,dashboard  }, ownProps) {
    var newState = { user, settings, wishlist, selectedOrder,customerZoneData: dashboard.customerZoneData, ...ownProps };    //customerDashboardData: dashboard.customerDashboardData,
    return newState;
}


MyProfile = connect(mapStateToProps, { saveProfile: saveProfile, getCustomerAvailableLoyaltyPointsBalance,getCustomerZoneData })(withRouter(MyProfile)) //getCustomerDashboardData

export default withTranslation()(MyProfile);




